import axios from "axios";

const superAdminApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + "/superadmin",
});

superAdminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("superadmin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default superAdminApi;
